module.exports = __webpack_public_path__ + "static/media/fruits_42.59cb14aa.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_42.csv
// module id = 709
// module chunks = 0